// @flow weak
/*
Sniff actions and track.
*/

import _ from 'lodash';
import { ROUTE_TO } from 'redux-router-kit';

import { RouterSelectors } from '@zapier/toolbox-redux-framework';
import { isInIframe } from '@zapier/common-utils';

import TrackActions from './tracking/Actions';
import FlowActionTypes from 'app/redux-boneyard/flow/ActionTypes';

const IS_IN_IFRAME = isInIframe();

const postToParent = data => {
  if (IS_IN_IFRAME) {
    window.parent.postMessage(data, '*');
  }
};

const postEventToParent = event => postToParent({ event });

export default ({ dispatch, getState }) => {
  const types = {
    [ROUTE_TO]: action => {
      const path = _.get(action, ['meta', 'location', 'pathname']);
      if (path) {
        dispatch(
          TrackActions.track('navigate', {
            path,
            release: process.env.COMMIT_HASH,
          })
        );
      }

      const isInitialPageLoad = !RouterSelectors.getCurrentPathname(getState());
      // We don't want to GA track the initial page load because
      // the GA script already does that by default for us.
      if (isInitialPageLoad) {
        return;
      }

      dispatch(TrackActions.gaPageTrack(path));
    },
    [FlowActionTypes.UNPAUSE_FLOW]: _.partial(postEventToParent, 'zap:unpause'),
    [FlowActionTypes.UNPAUSE_FLOW_DONE]: _.partial(
      postEventToParent,
      'zap:unpause:done'
    ),
    [FlowActionTypes.UNPAUSE_FLOW_FAIL]: _.partial(
      postEventToParent,
      'zap:unpause:fail'
    ),
    [FlowActionTypes.PAUSE_FLOW]: _.partial(postEventToParent, 'zap:pause'),
    [FlowActionTypes.PAUSE_FLOW_DONE]: _.partial(
      postEventToParent,
      'zap:pause:done'
    ),
    [FlowActionTypes.PAUSE_FLOW_FAIL]: _.partial(
      postEventToParent,
      'zap:pause:fail'
    ),
  };

  return next => action => {
    if (action && types[action.type]) {
      types[action.type](action);
    }

    return next(action);
  };
};
